<script>
  import { currentPage, totalPages } from "./stores/collection-products-store";
</script>

{#if $totalPages > $currentPage}
  <div class="flex justify-center my-5">
    <button on:click={() => currentPage.set(++$currentPage)} class="btn btn-transparent-black">
      Load more
    </button>
  </div>
{/if}
